const new3 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="7.24 2.75 3.5 9.28 6.77 9.28 4.9 13.95 12.84 6.48 8.82 6.48 11.9 2.75"/></svg>',
};

export { new3 as default };
